import type { TFunction } from 'i18next'
import type { z } from 'zod'
import { defaultRuleFactory } from '../rules/default-rules.ts'
import { createErrorMap } from '../utils/create-error-map.ts'

export const defaultRuleMapFactory = (
  t: TFunction<'validation'>
): z.ZodErrorMap => {
  return createErrorMap(t, defaultRuleFactory)
}
